export default __webpack_public_path__ + "static/FintechHero-f0e2e3262bbe9fb4d29016463cc55270.png";